import {config} from 'config';

export const environment = {
    production: true,
    ver: '18056',
    version: 'Ver: 03/06/2026 21:42:48',
    version_ts: '1780515768559',
    firebase: {
        apiKey: 'AIzaSyCiv74FkdNizesgiVNHSrPZUkN90LKZUD8',
        authDomain: 'optimise-enerplan.firebaseapp.com',
        databaseURL: 'https://optimise-enerplan.firebaseio.com',
        projectId: 'optimise-enerplan',
        storageBucket: 'optimise-enerplan.appspot.com',
        messagingSenderId: '559963427417',
        appId: '1:559963427417:web:b12c6f260ab82c2a369748',
        measurementId: "G-MXXLLMEMDX"
    },
    apiURL: config.apiUrl
};
